import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[inOnlyAlphabets]',
})
export class OnlyAlphabetsDirective {
  private specialKeys: Array<string> = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete',
    " "
  ];
  // eslint-disable-next-line class-methods-use-this
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
     if (this.specialKeys.indexOf(event.key) !== -1) {
       return true;
     }
    return this.validateAlphanumeric(event);
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return true;
    }
    return this.validateAlphanumeric(event);
  }

  validateAlphanumeric(event: KeyboardEvent) {
    const code = event.keyCode ? event.keyCode : 0;
    if (code === 8 || code === 0) {
      return true;
    } else if (code >= 65 && code <= 90) {
      return true;
    } else if (code >= 96 && code <= 122) {
      return true;
    } else if (event.ctrlKey) {
      return true;
    } else {
      return false;
    }
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  validateFields(event: KeyboardEvent) {
     setTimeout(() => {
       this.el.nativeElement.value = this.el.nativeElement.value
         .replace(/[^A-Za-z ]/g, '');
       event.preventDefault();
     }, 100);
  }
}
